import URL from '../url'
import Request from '../request'
import axios from 'axios'

/**
 *
 * @param {*} query
 */
export const courseListService = query =>
  new Request(URL.API, URL.COURSE_LIST).post(query)

/**
 *
 * @param {*} id
 */
export const courseGetService = id =>
  new Request(URL.API, URL.GET_COURSE.replace('{id}', id)).get()

/**
 *
 * @param {*} entity
 */
export const courseAddService = entity =>
  new Request(URL.API, URL.ADD_COURSE).post(entity)

/**
 *
 * @param {*} entity
 */
export const courseEditService = entity =>
  new Request(URL.API, URL.EDIT_COURSE).put(entity)

/**
 *
 * @param {*} id
 */
export const courseDeleteService = id =>
  new Request(URL.API, URL.DELETE_COURSE).delete({ id })

/**
 *
 * @param {*} content
 */
export const coursePatchService = content =>
  new Request(URL.API, URL.PATCH_COURSE + '?id=' + content.id).patch(content)

/**
 *
 * @param {*} id
 */
export const courseCloneService = code =>
  new Request(URL.API, URL.CLONE_COURSE).post({ code })

/**
 *
 * @param {*} code
 * @param {*} targetLanguage
 */
export const courseTranslateService = (code, targetLanguage) =>
  new Request(URL.API, URL.CLONE_COURSE).post({ code, targetLanguage })

/**
 * @param {*} id
 *
 */
export const courseSettingPatchService = content => {
  new Request(URL.API, URL.PATCH_COURSE_SETTING + '?id=' + content.id).patch(
    content.data,
  )
}

/**
 * @param {*} id
 *
 */
export const courseSettingCreateService = content =>
  new Request(URL.API, URL.CREATE_COURSE_SETTING).post(content)

/**
 * @param {*} courseId
 * @param {*} settingId
 * @param {*} data
 */
export const courseSettingPatchByIdService = (courseId, settingId, data) =>
  new Request(
    URL.API,
    URL.PATCH_COURSE_SETTING_BY_ID.replace('{id}', courseId).replace(
      '{settingId}',
      settingId,
    ),
  ).patch(data)

/**
 *
 * @param {*} starterText
 * @param {*} courseId
 * @param {*} cardId
 */

export const openaiSendCardRequestService = (starterText, courseId, cardId) =>
  new Request(URL.API, URL.OPENAI_SEND_CARD_REQUEST).post({
    starterText,
    courseId,
    cardId,
  })

/**
 *
 * @param {*} starterText
 */

export const aiInstructionRequestService = (starterText, language) =>
  new Request('https://ai-generation.minicoursegenerator.com', '/api/suggestionsSonnet55').post({
    source_text: starterText,
    language: language,
  })

/**

/**
 *
 * @param {*} profession
 * @param {*} audience
 * @param {*} description
 * @param {*} language
 * @param {*} purpose
 */
export const openaiSendCourseCreationGetTitleRequestService = (
  profession,
  audience,
  description,
  language,
  purpose,
) =>
  new Request(URL.API, URL.OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST).post({
    profession,
    audience,
    description,
    language,
    purpose,
  })

/**
 *
 * @param {*} profession,
 * @param {*} audience,
 * @param {*}title,
 * @param {*}language,
 * @param {*}purpose,
 */
export const openaiSendCourseCreationGetOutlineRequestService = (
  profession,
  audience,
  title,
  language,
  purpose,
) =>
  new Request(
    URL.API,
    URL.OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST,
  ).post({
    profession,
    audience,
    title,
    language,
    purpose,
  })

/**
 * @param {*}firstCardText
 * @param {*} profession
 * @param {*} title
 * @param {*} outlines
 * @param {*} audience
 * @param {*} description
 * @param {*} courseCollectionId
 * @param {*} language
 * @param {*} purpose
 * @param {*} selectedPreset
 */
export const openaiSendCourseCreationRequestService = (
  title,
  outlines,
  profession,
  audience,
  description,
  themeSettings,
  courseCollectionId,
  variables,
  gatewaySelection,
  language,
  purpose,
  imageGenerator,
  generateImage,
) =>
  new Request(URL.API, URL.OPENAI_SEND_COURSE_CREATION_REQUEST).post({
    title,
    outlines,
    profession,
    audience,
    description,
    themeSettings,
    courseCollectionId,
    variables,
    gatewaySelection,
    language,
    purpose,
    imageGenerator,
    generateImage,
  })

/**
 *
 * @param {*} code
 * @param {*} title
 * @param {*} collectionId
 */
export const coursetCloneTemplateCourseService = (code, title, collectionId) =>
  new Request(URL.API, URL.CLONE_TEMPLATE_COURSE).post({
    code,
    title,
    collectionId,
  })

/**
 *
 * @param {*} starterText
 */

export const sendCreatePromptFromCardContentRequestService = starterText =>
  new Request(URL.API, URL.CREATE_PROMPT_FROM_CARD).post({
    starterText,
  })

/**
 *
 * @param {*} courseId
 */

export const getCourseAnalyticsByIdService = courseId => {
  return new Request(URL.API, URL.GET_COURSE_ANALYTICS).post({
    courseId,
  })
}

/**
 * @param {*} courseId
 */
export const getCourseAnalyticsReportService = courseId => {
  return new Request(
    URL.API,
    URL.GET_COURSE_ANALYTICS_REPORT.replace('{id}', courseId),
  ).get()
}

/**
 *
 *
 */

export const createSectionWithCardIdsService = (courseId, name, cardIds) =>
  new Request(URL.API, URL.CREATE_SECTION_WITH_CARD_IDS).post({
    courseId,
    name,
    cardIds,
  })

/**
 *
 * @param {*} content
 */
export const sectionPatchService = content =>
  new Request(URL.API, URL.PATCH_SECTION + '?id=' + content.id).patch(content)

/**
 *
 * @param {*} courseId
 */
export const generateQuizzesByCourseIdService = courseId =>
  new Request(URL.API, URL.GET_QUIZZES_BY_COURSE_ID).post({ courseId })

/**
 *
 * @param {*} id
 */
export const courseCreationProgressService = id =>
  new Request(
    URL.API,
    URL.GET_COURSE_CREATION_PROGRESS.replace('{id}', id),
  ).get()

/**
 *
 * @param {*} id
 * @param {*} scormVersion
 */
export const exportCourseToScormService = (id, scormVersion) =>
  new Request(URL.API, URL.EXPORT_COURSE_TO_SCORM.replace('{id}', id)).post(
    {
      scormVersion: scormVersion,
    },
    {
      responseType: 'blob',
    },
  )

/**
 * @param {*} id
 * @param {*} sections
 */

export const editSectionOrderService = (id, sections) =>
  new Request(URL.API, URL.EDIT_SECTION_ORDER.replace('{id}', id)).put(sections)

export const addSectionService = data =>
  new Request(URL.API, URL.ADD_SECTION).post(data)

export const createCourseService = data =>
  new Request(URL.API, URL.CREATE_COURSE).post(data)

export const courseGetAssignmentService = id =>
  new Request(URL.API, URL.GET_ASSIGNMENT).get({ id })

export const generateCardService = data =>
  new Request(URL.API, URL.GENERATE_CARD).post(data)

/**
 * Generate interactive activity (game/puzzle) content from section IDs or free text.
 *
 * @param {Object} data
 * @param {string} data.type           Activity prompt key (e.g. "wordle", "crossword_puzzle").
 * @param {string[]} [data.sectionIds] Section UUIDs whose page contents seed the prompt.
 * @param {string} [data.content]      Free-form description (used when sectionIds are absent).
 * @param {string} [data.language]     ISO 639-1 language code; defaults to "en" server-side.
 */
export const generateActivityService = data =>
  new Request(URL.API, URL.GENERATE_ACTIVITY).post(data)

export const getCourseLandingPageService = id =>
  new Request(URL.API, URL.GET_COURSE_LANDING_PAGE.replace('{id}', id)).get()

export const landingPagePatchService = (id, data) =>
  new Request(URL.API, URL.PATCH_COURSE_LANDING_PAGE.replace('{id}', id)).patch(
    data,
  )

export const courseFilterService = data =>
  new Request(URL.API, URL.COURSE_FILTER).post(data)

export const getCourseAttachmentsService = courseId =>
  new Request(
    URL.APP_URL_LLM,
    URL.GET_COURSE_ATTACHMENTS.replace('{courseId}', courseId),
  ).get()

/**
 * Makes a mini course and all of its pages visible to learners.
 * @param {number} id course id
 */
export const publishCourseService = id =>
  new Request(URL.API, URL.PUBLISH_COURSE.replace('{id}', id)).post()

/**
 * Takes a mini course off the air. Learners lose access and the share link stops working.
 * @param {number} id course id
 */
export const unpublishCourseService = id =>
  new Request(URL.API, URL.UNPUBLISH_COURSE.replace('{id}', id)).post()

/**
 * Publishes the chosen subset of pending pages — what the "Publish changes" panel submits.
 * @param {number} id course id
 * @param {number[]} cardIds pages to publish
 */
export const publishCourseChangesService = (id, cardIds) =>
  new Request(URL.API, URL.PUBLISH_COURSE_CHANGES.replace('{id}', id)).post({
    cardIds,
  })

/**
 * Course publish state plus the per-page indicators the editor renders.
 * @param {number} id course id
 */
export const getCoursePublishStateService = id =>
  new Request(URL.API, URL.GET_COURSE_PUBLISH_STATE.replace('{id}', id)).get()

/**
 * Short-lived token letting Preview open a course that is not published yet.
 * @param {number} id course id
 */
export const getCoursePreviewTokenService = id =>
  new Request(URL.API, URL.GET_COURSE_PREVIEW_TOKEN.replace('{id}', id)).get()

/**
 * Changes the editable part of the course URL; the trailing number is kept. The old URL stops working.
 * @param {number} id course id
 * @param {string} slug the part before the number, already normalized
 */
export const updateCourseCodeService = (id, slug) =>
  new Request(URL.API, URL.UPDATE_COURSE_CODE.replace('{id}', id)).put({
    slug,
  })
